/**
 * Read a user-picked CSV/TXT file as text, auto-detecting the character encoding.
 *
 * Excel on Norwegian Windows saves "CSV (semikolondelt)" as ANSI (Windows-1252), not UTF-8.
 * Decoding those bytes as UTF-8 turns every ae/oe/aa into U+FFFD, so supplier price lists
 * imported as product names like "Honorar bes<?>k inntil 1 time". Valid UTF-8 is still decoded
 * as UTF-8; only files that are NOT valid UTF-8 fall back to Windows-1252.
 */

const decodeCsvBuffer = (buffer) => {
    const bytes = new Uint8Array(buffer);
    if (typeof TextDecoder === 'undefined') {
        // No TextDecoder (very old browsers): latin1 byte-per-char is closer than mojibake.
        return String.fromCharCode.apply(null, bytes);
    }
    try {
        // fatal:true makes an invalid UTF-8 sequence throw instead of yielding U+FFFD.
        return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
    } catch (e) {
        return new TextDecoder('windows-1252').decode(bytes);
    }
};

// Strip a leading BOM. TextDecoder drops the UTF-8 one, but a Windows-1252 decode turns those
// three bytes (EF BB BF) into the literal characters U+00EF U+00BB U+00BF.
const stripBom = text => String(text || '')
    .replace(/^\uFEFF/, '')
    .replace(/^\u00EF\u00BB\u00BF/, '');

const readCsvFile = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = ev => resolve(stripBom(decodeCsvBuffer(ev.target.result)));
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsArrayBuffer(file);
});

export { readCsvFile, decodeCsvBuffer, stripBom };
export default readCsvFile;
